import React from "react";

/* eslint-disable max-len */
export default function AdminProcessStatusIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <g data-name="\u30B0\u30EB\u30FC\u30D7 551">
                <path
                    data-name="\u524D\u9762\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3067\u578B\u629C\u304D 2"
                    d="M-3999-178a11.013 11.013 0 01-11-11 11.013 11.013 0 0111-11 11.013 11.013 0 0111 11 11.012 11.012 0 01-11 11zm-4.206-12.232l-1.6 1.538 4.744 4.571 6.859-6.607-1.574-1.539-5.239 5.026h-.09l-3.1-2.989z"
                    transform="translate(-40 -15) translate(4054 219)"
                    fill="#9c9c9c"
                />
            </g>
        </svg>
    );
}
